import { useMutation } from '@tanstack/react-query';
import useGetMutationFn from '../use-get-mutation-fn';

export type TemplateComponent = {
  type: 'header' | 'body' | 'footer' | 'buttons';
  format?: 'TEXT' | 'IMAGE' | 'VIDEO' | 'DOCUMENT';
  text?: string;
  buttons?: any[];
  example?: {
    body_text_named_params?: {
      param_name: string;
      example: string;
    }[];
  };
};

export type CreateTemplatePayload = {
  name: string;
  category: 'marketing' | 'utility' | 'authentication';
  components: TemplateComponent[];
  language?: string;
  allow_category_change?: boolean;
};

export type UpdateTemplatePayload = {
  name: string;
  category: 'marketing' | 'utility' | 'authentication';
  components: TemplateComponent[];
  language?: string;
  allow_category_change?: boolean;
  id: string
};

type MutationResponse = {
  timestamp: string;
  statusCode: number;
  status: string;
  message: string;
  data: any;
};

export const useCreateTemplateMutation = () => {
  const mutationFn = useGetMutationFn<CreateTemplatePayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred while creating WhatsApp Template',
    endpoint: '/api/admin/whatsapp/templates',
    method: 'POST',
  });

  return useMutation<MutationResponse, Error, CreateTemplatePayload>({ mutationFn });
};

export const useUpdateTemplateMutation = () => {
  const mutationFn = useGetMutationFn<UpdateTemplatePayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred while creating WhatsApp Template',
    endpoint: ({ id })=> `/api/admin/whatsapp/template/${id}`,
    method: 'PUT',
  });

  return useMutation<MutationResponse, Error, UpdateTemplatePayload>({ mutationFn });
};
